import Select from 'react-select';
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';

function NewAccommodation() {
  const { token, currentUser } = useContext(AuthContext);

  const services = [
    { id: 1, name: 'Cocina' },
    { id: 2, name: 'Piscina' },
    { id: 3, name: 'Internet' },
    { id: 4, name: 'Lavandería' },
    { id: 5, name: 'Agua' },
    { id: 6, name: 'Tv' },
    { id: 7, name: 'Luz' },
    { id: 8, name: 'Limpieza' },
    { id: 9, name: 'Gas' },
  ];
  const social_networks = [
    { id: 1, name: 'facebook' },
    { id: 2, name: 'instagram' },
    { id: 3, name: 'whatsapp' },
  ];
  const [isLoading, setIsLoading] = useState(false);

  const [errorSave, setErrorSave] = useState(false);
  const [errorSaveMessage, setErrorSaveMessage] = useState('');
  const [succesSave, setSuccesSave] = useState(false);
  const [succesSaveMessage, setSuccesSaveMessage] = useState('');

  const [countriesOptions, setCountriesOptions] = useState([]);
  const [regionsOptions, setRegionsOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [subwayOptions, setSubwayOptions] = useState([]);
  const [allRegions, setAllRegions] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedTitleEs, setSelectedTitleEs] = useState('');
  const [selectedTitleEn, setSelectedTitleEn] = useState('');
  const [selectedDescriptionEs, setSelectedDescriptionEs] = useState('');
  const [selectedDescriptionEn, setSelectedDescriptionEn] = useState('');
  const [selectedMapPosition, setSelectedMapPosition] = useState('');
  const [selectedRooms, setSelectedRooms] = useState(1);
  const [selectedRating, setSelectedRating] = useState(5);
  const [selectedFurnished, setSelectedFurnished] = useState('2');
  const [selectedBathrooms, setSelectedBathrooms] = useState(1);
  const [selectedSubway, setSelectedSubway] = useState(null);
  const [selectedServices, setSelectedServices] = useState([
    { id: 1, name: 'Cocina', checked: false },
    { id: 2, name: 'Piscina', checked: false },
    { id: 3, name: 'Internet', checked: false },
    { id: 4, name: 'Lavandería', checked: false },
    { id: 5, name: 'Agua', checked: false },
    { id: 6, name: 'Tv', checked: false },
    { id: 7, name: 'Luz', checked: false },
    { id: 8, name: 'Limpieza', checked: false },
    { id: 9, name: 'Gas', checked: false },
  ]);
  const [selectedContact, setSelectedContact] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
  });
  const [selectedWebsite, setSelectedWebsite] = useState('');
  const [selectedSocialNetworks, setSelectedSocialNetworks] = useState({});
  const [selectedImages, setSelectedImages] = useState(null);

  const [selectedDocuments, setSelectedDocuments] = useState({});

  const getRegions = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/es/regions`);
    const { regions: data } = response.data;

    const regionsAndCities = data.map(region => ({
      value: region.id,
      label: region.name,
      country_id: region.country ? region.country.id : null,
      cities: region.cities.map(city => ({
        value: city.id,
        label: city.name,
      })),
      subways: region.subways.map(subway => ({
        value: subway.id,
        label: subway.name,
      })),
    }));

    setAllRegions(regionsAndCities);
  };

  const getCountries = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/es/countries`);
    const options = response.data.countries.map(c => ({
      value: c.id,
      label: c.name,
      abbreviation: c.abbreviation,
    }));
    setCountriesOptions(options);
  };

  const handleServicesChange = (e, id) => {
    const updatedServices = selectedServices.map(service => {
      if (service.id === id) {
        return { ...service, checked: !service.checked };
      }
      return service;
    });
    setSelectedServices(updatedServices);
  };

  const handleCountryChange = selectedOption => {
    setSelectedCountry(selectedOption);
    setSelectedCity(null);
    setSelectedRegion(null);
    setSelectedSubway(null);
    setCitiesOptions([]);
    setSubwayOptions([]);

    const filteredRegions = allRegions.filter(r => r.country_id === selectedOption.value);
    setRegionsOptions(filteredRegions);
  };

  const handleRegionChange = selectedOption => {
    setSelectedRegion(selectedOption);
    if (selectedOption.cities.length === 0) {
      setSelectedCity(null);
    }
    setCitiesOptions(selectedOption.cities);
    setSubwayOptions(selectedOption.subways);
  };

  const extractErrorMessage = (
    error,
    defaultMessage = 'Ha ocurrido un error inesperado al guardar el alojamiento'
  ) => {
    if (!error) return defaultMessage;
    if (error.response) {
      const data = error.response.data;
      if (typeof data === 'string') {
        if (data.includes('<pre>')) {
          const match = data.match(/<pre>([\s\S]*?)<\/pre>/i);
          return match
            ? match[1]
                .replace(/<br\s*[\/]?>/gi, ' ')
                .split('\n')[0]
                .trim()
            : `Error ${error.response.status}`;
        }
        if (!data.trim().startsWith('<')) {
          return data;
        }
        return `Error del servidor (${error.response.status}: ${error.response.statusText || 'Error desconocido'})`;
      }
      if (data && typeof data === 'object') {
        if (data.error && typeof data.error === 'string') return data.error;
        if (data.message && typeof data.message === 'string') return data.message;
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          return data.errors
            .map(e => (typeof e === 'object' ? e.message || JSON.stringify(e) : e))
            .join(', ');
        }
        if (data.msg && typeof data.msg === 'string') return data.msg;
      }
    }
    if (error.message && typeof error.message === 'string') {
      return error.message;
    }
    return defaultMessage;
  };

  const selectedDocument = (name, files) => {
    setErrorSave(false);
    if (!files || files.length === 0) {
      return;
    }

    if (files[0].type !== 'application/pdf') {
      setErrorSave(true);
      const inputEl = document.getElementById(name);
      if (inputEl) inputEl.value = '';
      setErrorSaveMessage('Solo se permiten archivos PDF');
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    if (files[0].size > maxSize) {
      setErrorSave(true);
      const inputEl = document.getElementById(name);
      if (inputEl) inputEl.value = '';
      setErrorSaveMessage(`El archivo "${files[0].name}" excede el tamaño máximo permitido de 5MB`);
      return;
    }

    setSelectedDocuments({ ...selectedDocuments, [name]: files });
  };

  const handleImagesChange = e => {
    setErrorSave(false);
    const files = e.target.files;
    if (!files || files.length === 0) {
      return;
    }

    if (files.length > 10) {
      setErrorSave(true);
      e.target.value = '';
      setErrorSaveMessage('Se permite un máximo de 10 imágenes');
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

    for (let i = 0; i < files.length; i++) {
      if (!files[i].type.startsWith('image/')) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage('Solo se permiten archivos de imagen');
        return;
      }
      if (!allowedTypes.includes(files[i].type)) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage(
          `Formato de "${files[i].name}" no compatible. Solo se permiten imágenes JPEG, PNG o WEBP.`
        );
        return;
      }
      if (files[i].size > maxSize) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage(
          `La imagen "${files[i].name}" excede el tamaño máximo permitido de 5MB`
        );
        return;
      }
    }

    setSelectedImages(files);
  };

  const handleSaveAccommodation = async () => {
    setErrorSave(false);
    setSuccesSave(false);
    setIsLoading(true);
    const lang = 'es';

    const services = JSON.stringify(selectedServices);
    const contact = JSON.stringify(selectedContact);
    const social_networks = JSON.stringify(selectedSocialNetworks);

    if (!selectedTitleEs || !selectedTitleEn || !selectedCountry) {
      setErrorSave(true);
      setErrorSaveMessage('Título (en y es) y País son requeridos');
      setIsLoading(false);
      return;
    }

    if (selectedCountry.abbreviation === 'CL' && !selectedCity) {
      setErrorSave(true);
      setErrorSaveMessage('Ciudad es requerida para Chile');
      setIsLoading(false);
      return;
    }

    // validar que si o si se adjunten al menos 3 imagenes
    if (!selectedImages || selectedImages.length < 3) {
      setErrorSave(true);
      setErrorSaveMessage('Se requieren al menos 3 imágenes');
      setIsLoading(false);
      return;
    }

    const data = {
      country_id: selectedCountry.value,
      city_id: selectedCity ? selectedCity.value : null,
      title_es: selectedTitleEs,
      title_en: selectedTitleEn,
      description_es: selectedDescriptionEs,
      description_en: selectedDescriptionEn,
      rating: selectedRating,
      rooms: selectedRooms,
      furnished: selectedFurnished,
      bathrooms: selectedBathrooms,
      closest_subway: selectedSubway ? selectedSubway.value : null,
      services,
      contact,
      website: selectedWebsite,
      map_position: selectedMapPosition,
      social_networks,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    // images
    for (let i = 0; i < selectedImages.length; i++) {
      formData.append('images', selectedImages[i]);
    }

    // documents
    if (selectedDocuments.path_erut) {
      formData.append('path_erut', selectedDocuments.path_erut[0]);
    }
    if (selectedDocuments.path_te1) {
      formData.append('path_te1', selectedDocuments.path_te1[0]);
    }
    if (selectedDocuments.path_sello_verde) {
      formData.append('path_sello_verde', selectedDocuments.path_sello_verde[0]);
    }
    if (selectedDocuments.path_seremi) {
      formData.append('path_seremi', selectedDocuments.path_seremi[0]);
    }
    if (selectedDocuments.path_patente) {
      formData.append('path_patente', selectedDocuments.path_patente[0]);
    }
    if (selectedDocuments.path_contrato) {
      formData.append('path_contrato', selectedDocuments.path_contrato[0]);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/accommodations`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSuccesSave(true);
        setSuccesSaveMessage(response.data.message || 'Alojamiento creado correctamente');
        setIsLoading(false);
      } else {
        setErrorSave(true);
        setErrorSaveMessage('No se pudo guardar el alojamiento');
      }
    } catch (error) {
      const msg = extractErrorMessage(error);
      setErrorSave(true);
      setErrorSaveMessage(msg);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      // window.location.href = '/';
    }

    getCountries();
    getRegions();
  }, [token]);

  return (
    <>
      <div className="container">
        <h1 className="my-3">New Accommodation</h1>
        <div className="row">
          <div className="shadow p-3 mb-3 rounded border" id="region_city_section">
            <div className="row">
              <div className="col-4">
                <label htmlFor="country" className="col-form-label">
                  País <span className="text-danger">*</span>
                </label>
                <div className="">
                  <Select
                    id="country"
                    name="country"
                    aria-label="Default select example"
                    options={countriesOptions}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                  />
                </div>
              </div>
              {selectedCountry && selectedCountry.abbreviation === 'CL' && (
                <>
                  <div className="col-4">
                    <label htmlFor="region" className="col-form-label">
                      Región
                    </label>
                    <div className="">
                      <Select
                        id="region"
                        name="region"
                        aria-label="Default select example"
                        options={regionsOptions}
                        value={selectedRegion}
                        onChange={handleRegionChange}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <label htmlFor="city" className="col-form-label">
                      Ciudad <span className="text-danger">*</span>
                    </label>
                    <div className="">
                      <Select
                        id="city"
                        name="city"
                        aria-label="Default select example"
                        options={citiesOptions}
                        value={selectedCity}
                        onChange={selectedOption => setSelectedCity(selectedOption)}
                      />
                    </div>
                  </div>
                  <div className="col-4 mt-3">
                    <label htmlFor="closest_subway" className="col-form-label">
                      Metro más cercano
                    </label>
                    <div className="">
                      <Select
                        id="closest_subway"
                        name="closest_subway"
                        aria-label="Default select example"
                        options={subwayOptions}
                        value={selectedSubway}
                        onChange={selectedOption => setSelectedSubway(selectedOption)}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="shadow p-3 mb-3 rounded border" id="title_section">
            <div className="row">
              {/* rooms */}
              <div className="col-3">
                <label htmlFor="rooms" className="col-form-label">
                  Habitaciones
                </label>
                <div className="">
                  <input
                    type="number"
                    className="form-control"
                    id="rooms"
                    name="rooms"
                    value={selectedRooms}
                    onChange={e => setSelectedRooms(e.target.value)}
                  />
                </div>
              </div>
              {/* rating */}
              <div className="col-3">
                <label htmlFor="rating" className="col-form-label">
                  Calificación
                </label>
                <div className="">
                  <input
                    type="number"
                    step="0.5"
                    min="1"
                    max="5"
                    className="form-control"
                    id="rating"
                    name="rating"
                    value={selectedRating}
                    onChange={e => setSelectedRating(e.target.value)}
                  />
                </div>
              </div>
              {/* furnished */}
              <div className="col-3">
                <label htmlFor="furnished" className="col-form-label">
                  Amoblado?
                </label>
                <div className="">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="furnished-yes"
                      name="furnished"
                      value="1"
                      checked={selectedFurnished === '1'}
                      onChange={e => setSelectedFurnished(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="furnished-yes">
                      Sí
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="furnished-no"
                      name="furnished"
                      value="2"
                      checked={selectedFurnished === '2'}
                      onChange={e => setSelectedFurnished(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="furnished-no">
                      No
                    </label>
                  </div>
                </div>
              </div>
              {/* bathrooms */}
              <div className="col-3">
                <label htmlFor="bathrooms" className="col-form-label">
                  Baños
                </label>
                <div className="">
                  <input
                    type="number"
                    className="form-control"
                    id="bathrooms"
                    name="bathrooms"
                    value={selectedBathrooms}
                    onChange={e => setSelectedBathrooms(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <label htmlFor="title_es" className="col-form-label">
                  Nombre [es] <span className="text-danger">*</span>
                </label>
                <div className="">
                  <input
                    type="text"
                    className="form-control"
                    id="title_es"
                    name="title_es"
                    value={selectedTitleEs}
                    onChange={e => setSelectedTitleEs(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="title_en" className="col-form-label">
                  Nombre [en] <span className="text-danger">*</span>
                </label>
                <div className="">
                  <input
                    type="text"
                    className="form-control"
                    id="title_en"
                    name="title_en"
                    value={selectedTitleEn}
                    onChange={e => setSelectedTitleEn(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <label htmlFor="description_es" className="col-form-label">
                  Descripción [es]
                </label>
                <div className="">
                  <textarea
                    className="form-control"
                    id="description_es"
                    name="description_es"
                    rows="3"
                    onChange={e => setSelectedDescriptionEs(e.target.value)}
                    value={selectedDescriptionEs}
                  />
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="description_en" className="col-form-label">
                  Descripción [en]
                </label>
                <div className="">
                  <textarea
                    className="form-control"
                    id="description_en"
                    name="description_en"
                    rows="3"
                    onChange={e => setSelectedDescriptionEn(e.target.value)}
                    value={selectedDescriptionEn}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="" id="services_section">
            <div className="row">
              {/* services */}
              <div className="col-4 ps-0">
                <div className="shadow p-3 mb-3 rounded border">
                  <label htmlFor="services" className="col-form-label">
                    Servicios
                  </label>
                  <div className="row ms-1">
                    {services.map(service => (
                      <div className="mb-2 form-check col-12" key={service.id}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={service.name}
                          name={service.name}
                          value={service.id}
                          onChange={e => handleServicesChange(e, service.id)}
                        />
                        <label className="form-check-label" htmlFor={service.name}>
                          {service.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* contacto */}
              <div className="col-8 shadow p-3 mb-3 rounded border">
                <label htmlFor="contact" className="col-form-label">
                  Contacto
                </label>
                <div className="row">
                  <div className="mb-2 col-7">
                    <label htmlFor="nombre" className="form-label">
                      Nombre
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="nombre"
                      name="nombre"
                      value={selectedContact.name}
                      onChange={e =>
                        setSelectedContact({
                          ...selectedContact,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="clearfix"></div>
                  <div className="mb-2 col-7">
                    <label htmlFor="direccion" className="form-label">
                      Dirección
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="direccion"
                      name="direccion"
                      value={selectedContact.address}
                      onChange={e =>
                        setSelectedContact({
                          ...selectedContact,
                          address: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-2 col-5">
                    <label htmlFor="map_position" className="form-label">
                      Coordenadas Mapa
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="map_position"
                      name="map_position"
                      value={selectedMapPosition}
                      onChange={e => setSelectedMapPosition(e.target.value)}
                    />
                  </div>
                  <div className="col-4">
                    <label htmlFor="telefono" className="form-label">
                      Teléfono
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="telefono"
                      name="telefono"
                      value={selectedContact.phone}
                      onChange={e =>
                        setSelectedContact({
                          ...selectedContact,
                          phone: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-4">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={selectedContact.email}
                      onChange={e =>
                        setSelectedContact({
                          ...selectedContact,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-4">
                    <label htmlFor="web" className="form-label">
                      Web
                    </label>
                    <input
                      type="url"
                      className="form-control"
                      id="web"
                      name="web"
                      value={selectedWebsite}
                      onChange={e => setSelectedWebsite(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shadow p-3 mb-3 rounded border" id="rrss_section">
            <div className="row">
              {social_networks.map(social_network => (
                <div className="col-4" key={social_network.id}>
                  <label htmlFor="{social_network.name}" className="form-label">
                    {social_network.name}
                    {social_network.name != 'whatsapp' ? (
                      <> (usuario sin @)</>
                    ) : (
                      <> (solo números, ej: 56912341234)</>
                    )}
                  </label>
                  <input
                    type="url"
                    className="form-control"
                    id="{social_network.name}"
                    name="{social_network.name}"
                    value={selectedSocialNetworks[social_network.name]}
                    onChange={e =>
                      setSelectedSocialNetworks({
                        ...selectedSocialNetworks,
                        [social_network.name]: e.target.value,
                      })
                    }
                  />
                </div>
              ))}
            </div>
          </div>

          {/* imagenes */}
          <div className="shadow p-3 mb-3 rounded border" id="images_section">
            <div className="row">
              <div className="col-12">
                <label htmlFor="images" className="form-label">
                  Imágenes (Al menos 3 requeridas) <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="images"
                  name="images"
                  accept="image/*"
                  multiple
                  onChange={handleImagesChange}
                />
              </div>
            </div>
          </div>

          <div className="shadow p-3 mb-3 rounded border" id="images_section">
            <div className="row">
              <div className="col-12">
                <label htmlFor="documentos" className="form-label">
                  Documentos (PDF)
                </label>
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="path_erut" className="form-label">
                  Registro empresa
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_erut"
                  name="path_erut"
                  onChange={e => selectedDocument('path_erut', e.target.files)}
                />
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="path_te1" className="form-label">
                  Certificados
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_te1"
                  name="path_te1"
                  onChange={e => selectedDocument('path_te1', e.target.files)}
                />
              </div>
              <div className="col-12 mt-2 d-none">
                <label htmlFor="path_sello_verde" className="form-label">
                  Sello Verde
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_sello_verde"
                  name="path_sello_verde"
                  onChange={e => selectedDocument('path_sello_verde', e.target.files)}
                />
              </div>
              <div className="col-12 mt-2 d-none">
                <label htmlFor="path_seremi" className="form-label">
                  Seremi
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_seremi"
                  name="path_seremi"
                  onChange={e => selectedDocument('path_seremi', e.target.files)}
                />
              </div>
              <div className="col-12 mt-2 d-none">
                <label htmlFor="path_patente" className="form-label">
                  Patente
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_patente"
                  name="path_patente"
                  onChange={e => selectedDocument('path_patente', e.target.files)}
                />
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="path_contrato" className="form-label">
                  Contrato
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="path_contrato"
                  name="path_contrato"
                  onChange={e => selectedDocument('path_contrato', e.target.files)}
                />
              </div>
            </div>
          </div>

          <div className="px-0 mt-2 mb-4 text-end">
            {errorSave && (
              <div className="alert alert-danger" role="alert">
                {errorSaveMessage || 'Ha ocurrido un error inesperado al guardar el alojamiento'}
              </div>
            )}
            {succesSave && (
              <div className="alert alert-success" role="alert">
                {succesSaveMessage}
              </div>
            )}

            {isLoading ? (
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <button
                type="button"
                onClick={handleSaveAccommodation}
                className={succesSave ? 'd-none' : 'btn btn-dark'}
              >
                Guardar
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewAccommodation;
